module.exports = __webpack_public_path__ + "static/media/4-vrt.3fa458c0.mp3";